import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      "One source document (RFP, SOW, BD note, etc.) belonging to a project, used as the basis for generating that project's engagement charter.",
    name: 'Engagement Charter Components',
    partialId: PartialId.Standard.create('engagement_charter_comps'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
